import { IAddress } from "../../../interfaces";

const CommonAddressCard = ({
  address,
  orderEmail,
}: {
  address: IAddress;
  orderEmail?: string;
}) => {
  return (
    <div className="addressdetail">
      <ul className="text-sm">
        <li className="text-sm">{address.companyName}</li>
        <li className="text-sm">{address.addressLine1}</li>
        <li className="text-sm">
          {address.zipCode} {address.city}{" "}
        </li>
        <li></li>
        <li className="text-sm">{address.country}</li>
        <li className="text-sm">{address.phone}</li>
        {orderEmail && (
          <li className="row text-sm">
            <div className="white-space-no-wrap text-sm"></div>
            <div className="word-break-break-all text-sm"> {orderEmail}</div>
          </li>
        )}
      </ul>
    </div>
  );
};
export default CommonAddressCard;
